// import { changesFieldLabel } from '../const';
import '../styles.css';

export default function ProductInput({ name, value, changesField = [] }) {
  /*
   * field_name = column in db
   * fieldName = parameter name
   * need to configure first in BE if field_name and fieldName is not equal
   * ProductsController->detectChanges
   */
  const is_included = changesField.some((obj) => {
    let fieldName = null;

    if (obj.field_name === 'brand_name') {
      fieldName = 'generic_name';
    } else if (obj.field_name === 'cost_unit_vat') {
      fieldName = 'cost_vat_unit';
    } else {
      fieldName = obj.field_name;
    }

    return fieldName === name;
  })
    ? 'red-input'
    : '';

  return (
    <input
      type="text"
      className={`form-control form-control-sm text-dark ${is_included}`}
      name={name}
      id={name}
      value={value}
      style={{ marginTop: '6px' }}
      readOnly
    />
  );
}
